/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {motion} from "motion/react";
import {StatesAPI} from "../../APIs/StatesApi.js";
import Strings from "toolbox/strings";

class GridElement extends Component {
    constructor() {
        super();
        this.state = {
            currentState: {}
        }
    }

    async fetchData() {
        let {name, elementId} = this.props
        let result = await StatesAPI.getStateHistory(name, elementId, 3)
        result = result.sort((a, b) => (b.time - a.time))
        this.setState({currentState: result?.[0]})
    }

    componentDidMount() {
        this.fetchData()

        this.interval = setInterval(() => {
            this.fetchData()
        }, 10000)
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.name !== this.props.name || prevProps.elementId !== this.props.elementId) {
            this.fetchData()
        }
    }

    render() {
        let {onClick,} = this.props
        let {currentState,} = this.state

        let state = currentState?.state ?? ""

        let className = "bg-yellow-50 text-yellow-800  ring-yellow-600/20"

        if (state === "ok") {
            className = "bg-green-50 text-green-700 ring-green-600/20"
        } else if (Strings.isEmpty(state)) {
            className = "bg-green-50 text-green-700 ring-green-600/20"
        } else if (state.startsWith("inSetup")) {
            className = "bg-blue-50 text-blue-700 ring-blue-600/20"
        } else {
            className = "bg-red-50 text-red-700 ring-red-600/20"
        }


        return (
            <>
                <motion.div
                    onClick={onClick}
                    layout
                    className={` items-center rounded-xl h-12 w-12 flex justify-center px-2 py-1 text-xs font-medium  ring-1 ring-inset overflow-hidden ${className}`}>{currentState?.state}</motion.div>

            </>
        );
    }
}

GridElement.propTypes = {};

GridElement.defaultProps = {};


export default GridElement;